import PricingRoom from '@app/model/pricing-automation/PricingRoom';
import HotelRoomMappingType from '@app/model/market_state/HotelRoomMappingType';
import PricingArchitectureDerivative from '@app/model/pricing-automation/PricingArchitectureDerivative';
import PricingStrategy from '@app/model/pricing-automation/PricingStrategy';

class PricingArchitecture {
	id: number;
	anchor: PricingRoom;
	competitorsMappingType: HotelRoomMappingType;
	derivatives: PricingArchitectureDerivative[];
	strategy: PricingStrategy;
	hasStrategy: boolean;
	orderIndex: number;

	constructor(data: PricingArchitecture) {
		Object.assign(this, data);
	}

	public findRoomById(roomId: number): PricingRoom | undefined {
		if(this.anchor.id === roomId) return this.anchor;
		return this.derivatives.find(d => d.pricingRoom.id === roomId)?.pricingRoom;
	}
}

export default PricingArchitecture;
